import { render } from "./ListasPrecios.vue?vue&type=template&id=1b0c9063&scoped=true"
import script from "./ListasPrecios.vue?vue&type=script&lang=js"
export * from "./ListasPrecios.vue?vue&type=script&lang=js"

import "./ListasPrecios.vue?vue&type=style&index=0&id=1b0c9063&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0c9063"]])

export default __exports__